import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  filter: {
    daysTab: "today",
    startDate: "",
    endDate: "",
    status: "All",
    voucherTab: "Order",
    selectedWarehouseId: "",
    selectedManagerID: null,
    keyword: "",
    selectedOrderWarehouse: {},
    // debouncedKeyword: "",
  },
  pagination: {
    page: 1,
    pages: 1,
    // limit: 1,
  },
  ui: {
    isSearchBarOpen: false,
  },
};

const dispatchSlice = createSlice({
  name: "dispatch",
  initialState,
  reducers: {
    setFilter: (state, action) => {
      state.filter = { ...state.filter, ...action.payload };
    },
    setPagination: (state, action) => {
      state.pagination = { ...state.pagination, ...action.payload };
    },
    setUi: (state, action) => {
      state.ui = { ...state.ui, ...action.payload };
    },
    resetAll: () => initialState,
  },
});

export const { setFilter, setPagination, setUi, resetAll } =
  dispatchSlice.actions;

export default dispatchSlice.reducer;
